import { useFormContext } from 'react-hook-form';

import {
  CalculationMethodFormValues,
  isCalculationMethodVisible,
} from '../utils/calculationMethodVisibility';

export const useCalculationMethodVisibility = (): boolean => {
  const { watch } = useFormContext<CalculationMethodFormValues>();

  return isCalculationMethodVisible(watch('rate'));
};
